import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLightbulb = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M15 14.2c.2-1 .7-1.75 1.5-2.5A5.75 5.75 0 1 0 7.5 11.7c.8.75 1.3 1.5 1.5 2.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M9.2 17.8h5.6M10.2 21h3.6" })
	]
});
const ForwardRef = forwardRef(SvgLightbulb);
export default ForwardRef;
